import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter, withRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { store } from "./_store"
import "normalize.css"
import "./index.css"
import App from "./App"
//import registerServiceWorker from "./registerServiceWorker"

//Scroll to top in location change default
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

const ScrollRestoration = withRouter(ScrollToTop)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollRestoration>
        <App />
      </ScrollRestoration>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
)
//registerServiceWorker()
